import { Component } from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { IonicPage, NavController, NavParams } from 'ionic-angular'
import { filter, map, take } from 'rxjs/operators'

import { User } from '../../models/models'
import { UserAuthProvider } from '../../modules/mrk-user-auth/user-auth'

@IonicPage()
@Component({
  selector: 'page-shortcuts',
  templateUrl: 'shortcuts.html',
})
export class ShortcutsPage {

  email = ''
  url: SafeResourceUrl


  constructor(public navCtrl: NavController, public navParams: NavParams, userProvider: UserAuthProvider<User>, s : DomSanitizer) {

    userProvider.userState.pipe(
      filter(state => state.logged),
      take(1),
      map(state => state.user.email)
      ).subscribe( email => {
        this.email = email
        this.url = s.bypassSecurityTrustResourceUrl(`https://doc.mypushop.com/app-venditori/?email=${email}`)
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/shortcuts/shortcuts.ts